export default "__VITE_ASSET__ab6bbc19__"